import PERMISSIONS_LIST from '../../../../submodules/web-shared/modules/Permissions/permissions-list';
import { portalLevelPermissions } from '../../../../submodules/web-shared/modules/Permissions/PortalLevelPermissions';
import { useUserCompanies } from '../../../../submodules/web-shared/reducers/user-companies/hooks';
import { COMPANY_SETTING_NAME } from '../../../global/modules/companies/api/company-settings/enums/company-settings';
import { KPI_NAME } from '../../shared/consts/kpi';
import { permissionByKPIName } from './const';

const useDashboardsAccess = () => {
  const { isCompanySettingEnabled } = useUserCompanies();

  const hasPermission = (permission: PERMISSIONS_LIST) => {
    return portalLevelPermissions.isPermissionEnabled(permission, null);
  };

  const hasDashboardsAccess = () => {
    return isCompanySettingEnabled(COMPANY_SETTING_NAME.COMMAND_CENTER_ACCESS)
      && hasPermission(PERMISSIONS_LIST.command_center_dashboard);
  };

  const hasLayoutChangeAccess = () => {
    return hasDashboardsAccess() && hasPermission(PERMISSIONS_LIST.personalize_dashboard_layouts);
  };

  const hasToggleWidgetAccess = () => {
    return hasDashboardsAccess() && hasPermission(PERMISSIONS_LIST.hide_display_dashboard_widgets);
  };

  const hasEditDashboardAccess = () => hasLayoutChangeAccess() || hasToggleWidgetAccess();

  const hasSaveDashboardAccess = () => {
    return hasDashboardsAccess() && hasPermission(PERMISSIONS_LIST.dashboard_save);
  };

  const hasShareDashboardAccess = () => {
    return hasDashboardsAccess() && hasPermission(PERMISSIONS_LIST.dashboard_share);
  };

  const hasKPIAccess = (kpiName: KPI_NAME) => {
    return hasDashboardsAccess() && hasPermission(permissionByKPIName[kpiName]);
  };

  return {
    hasDashboardsAccess,
    hasLayoutChangeAccess,
    hasToggleWidgetAccess,
    hasEditDashboardAccess,
    hasSaveDashboardAccess,
    hasShareDashboardAccess,
    hasKPIAccess
  };
};

export default useDashboardsAccess;